import { useTranslation } from 'react-i18next';
import { renderMarkdown } from '@/lib/markdown';

/** Live markdown preview — the same renderer the bubble will use, so what
 *  you see is what lands in the channel. Sits above the textarea (so it
 *  doesn't shift the send/attach controls) with a capped, scrollable height
 *  so a long draft can't push the composer off-screen. */
export function LivePreviewPanel(props: { draft: string }) {
  const { t } = useTranslation();
  return (
    <div
      className="mb-1.5 max-h-[40vh] overflow-y-auto rounded-xl px-3 py-2 text-sm leading-snug scrollbar-thin"
      style={{
        backgroundColor: 'rgb(var(--surface-card) / 0.6)',
        backdropFilter: 'blur(6px) saturate(140%)',
        WebkitBackdropFilter: 'blur(6px) saturate(140%)',
        boxShadow: 'inset 0 0 0 1px rgb(var(--ring-inset) / var(--ring-inset-alpha))',
      }}
    >
      <div className="font-medium mb-1.5 text-[10px] !text-accent">{t('ui.composer.preview')}</div>
      <div className="text-ink">{renderMarkdown(props.draft)}</div>
    </div>
  );
}
